module.exports = __webpack_public_path__ + "static/img/interpretive-graphic-design05.807c4c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/graphic-design/interpretive-graphic-design05.jpg
// module id = 1004
// module chunks = 0